import { Environment } from '@fabrik/common'

export const environment: Environment = {
    production: true,
    hideNavItems: true,
    tokenKey: 'FBR_CMMNT_CNT_TKN',
    adCMSApiHost: 'https://adcms.fabrik.fm',
    authHost: 'https://identity.fabrik.fm/',
    authClientId: 'ccf5a036-032f-42c2-b050-7cba9bf18aee',
    appApiHost: 'https://app.fabrik.fm',
    fabrikAIHost: 'https://app-ai.fabrik.fm',
    echocastHost: 'https://echocast.fabrik.fm',
    fabrikFormsHost: 'https://app.fabrik.fm',
    fabrikFrontEndHost: ' https://forms.fabrik.fm',
    metricsHost: 'https://metrics.fabrik.fm',
    metricsApiHost: 'https://fabrik-metric-viewer-production-api-linux-cdhgg8b0exafc2gk.westeurope-01.azurewebsites.net/api',
    matomoHost: 'https://matomo.fabrik.fm/',
    matomoId: 114,
    smashboardHost: 'https://smashboard.fabrik.fm',
    smashboardAPI: 'https://api-smashboard.fabrik.fm',
    podcastBase: 'https://streaming.fabrik.fm/fabrik/echocast/player/rewind/podcast-player.html',
    livestreamBase: 'https://streaming.fabrik.fm/fabrik/echocast/player/live/player.html',
    singlepodcastBase: 'https://streaming.fabrik.fm/fabrik/echocast/player/rewind-single/player.html',
    enableHttpsRedirect: true,
    bundledBaseUrl: 'https://fabrikstore.blob.core.windows.net/bundled-images/chat-groups',
    availableLanguages: ['en'],
    defaultLanguage: 'en',
    defaultPageSize: 25,
    defaultPageSizeOptions: [25, 50, 75, 100],
    identityTenantId: 'ba3fb062-20b4-4661-9b26-8f35190a15b9',
    googleMapKey: 'AIzaSyCIc8_0VApTJA--OCljeBToZ4Y_ZXRCVGo',
    echoLimit: 15,
    echoGeneralPresetName: 'General',
    echoGeneralPresetId: '-1',    
    nowInternalMetricsDelayInMinutes: 6,
    isHideInReviewFeature: true
}
